import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const path = "restaurant/product"
const options = { role: ROLE.RESTAURANT };

export const add = async (values) => {
  return await axiosInstance(options).post(`${path}/add`, values);
}

export const list = async (values) => {
  return await axiosInstance(options).post(`${path}/list`, values);
};

// // Vendor Details 

export const Details = async (values) => {
  return await axiosInstance(options).get(
    `${path}/details?o_id=${values.o_id}`
  );
}

export const editProduct = async (values) => {
  return await axiosInstance(options).put(`${path}/update`, values);
};

export const deleteProduct = async (values) => {
  return await axiosInstance(options).post(`${path}/delete`, values);
};
